import React from "react";
import { C, CLUSTERS, CORPUS_KPIS, DQ_NOTE, HONEST_NOTE, IDENTIFIERS, MODEL_PERF, VOLUME } from "./data";
import { BarChart, Eyebrow, KpiRow, cell, colHead } from "./shared";

export function CorpusInsightsAndModelsView() {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <KpiRow items={CORPUS_KPIS} />
      <div style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: 16, padding: 24, display: "flex", flexDirection: "column", gap: 16 }}>
        <Eyebrow>Exploratory Data Analysis – Mailbox Corpus</Eyebrow>
        <div style={{ display: "flex", gap: 32, flexWrap: "wrap" }}>
          <BarChart title="Volume by month (peak at period close)" rows={VOLUME} labelW={36}
            gradFrom={C.triage1} gradTo={C.triage2} chipBg={C.triage1} chipColor="#fff" maxVal={840} />
          <div style={{ flex: 1, minWidth: 280, display: "flex", flexDirection: "column", gap: 12 }}>
            <BarChart title="Identifier availability in the mail body" rows={IDENTIFIERS} labelW={140}
              gradFrom={C.purple} gradTo={C.triage1} chipBg={C.tagPurpleBg} chipColor={C.purple} maxVal={58} suffix="%" />
            <p style={{ margin: 0, paddingTop: 4, color: C.gray, fontSize: 11, lineHeight: 1.4 }}>{DQ_NOTE}</p>
          </div>
        </div>
      </div>
      <div style={{ background: C.white, border: `1px solid ${C.border}`, borderRadius: 16, padding: 24, display: "flex", flexDirection: "column", gap: 16 }}>
        <Eyebrow>Text Analytics &amp; Clustering – Intent Taxonomy</Eyebrow>
        <div className="np-scroll" style={{ overflowX: "auto" }}>
          <div style={{ minWidth: 900 }}>
            <div style={{ display: "flex", background: C.tableHeadBg, border: `1px solid ${C.border}`, padding: "12px 16px" }}>
              <span style={colHead(60)}>Cluster</span><span style={colHead(240)}>Theme</span><span style={colHead(80)}>Share</span>
              <span style={colHead(100)}>Mails</span><span style={{ ...colHead(0), flex: 1 }}>Agent Play</span><span style={colHead(180)}>Automation Confidence</span>
            </div>
            {CLUSTERS.map((row) => (
              <div key={row.c} style={{ display: "flex", alignItems: "center", padding: "12px 16px", borderBottom: `1px solid ${C.border}` }}>
                <span style={{ ...cell(60), color: C.ink2, fontWeight: 600, fontSize: 13 }}>{row.c}</span>
                <span style={{ ...cell(240), color: C.ink2, fontSize: 13 }}>{row.theme}</span>
                <span style={{ ...cell(80), color: C.muted, fontSize: 13 }}>{row.share}</span>
                <span style={{ ...cell(100), color: C.muted, fontSize: 13 }}>{row.mails}</span>
                <span style={{ flex: 1, minWidth: 0, color: C.ink2, fontSize: 13 }}>{row.play}</span>
                <div style={cell(180)}>
                  <span style={{ display: "inline-flex", alignItems: "center", height: 21, padding: "0 10px", borderRadius: 6,
                    background: row.human ? C.humanBg : C.clusterGreenBg, color: row.human ? C.humanText : C.clusterGreen, fontWeight: 600, fontSize: 11 }}>{row.conf}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div style={{ marginTop: 8 }}><Eyebrow>Classification Model Performance</Eyebrow></div>
        <div className="np-scroll" style={{ overflowX: "auto" }}>
          <div style={{ minWidth: 640 }}>
            <div style={{ display: "flex", background: C.tableHeadBg, border: `1px solid ${C.border}`, padding: "12px 16px" }}>
              <span style={{ ...colHead(0), flex: 1 }}>Intent</span><span style={colHead(180)}>Precision</span>
              <span style={colHead(180)}>Recall</span><span style={colHead(180)}>F1</span>
            </div>
            {MODEL_PERF.map((row) => (
              <div key={row.intent} style={{ display: "flex", alignItems: "center", padding: "12px 16px", borderBottom: `1px solid ${C.border}` }}>
                <span style={{ flex: 1, minWidth: 0, color: C.ink2, fontWeight: 600, fontSize: 13 }}>{row.intent}</span>
                <span style={{ ...cell(180), color: C.muted, fontSize: 13 }}>{row.p}</span>
                <span style={{ ...cell(180), color: C.muted, fontSize: 13 }}>{row.r}</span>
                <span style={{ ...cell(180), color: C.purple, fontWeight: 600, fontSize: 13 }}>{row.f1}</span>
              </div>
            ))}
          </div>
        </div>
        <div style={{ background: C.holdBg, border: `1px solid ${C.holdBorder}`, borderRadius: 12, padding: 20, display: "flex", flexDirection: "column", gap: 8, marginTop: 4 }}>
          <span style={{ color: C.purple, fontWeight: 700, fontSize: 12, textTransform: "uppercase" }}>How the model is kept honest</span>
          <p style={{ margin: 0, color: C.muted, fontSize: 12, lineHeight: 1.4 }}>{HONEST_NOTE}</p>
        </div>
      </div>
    </div>
  );
}
